import React from "react";

interface FileFiltersProps {
  filterValue: string;
  setFilterValue: (filterValue: string) => void;
}

const FileFilters: React.FC<FileFiltersProps> = ({
  filterValue,
  setFilterValue,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterValue(e.target.value);
  };

  return (
    <div>
      <form className="flex-1" onSubmit={e => e.preventDefault()}>
        <div className="text-green-700 text-sm font-bold mb-2">
          Include Pattern
        </div>
        <input
          data-testid="patternFilterInput"
          type="text"
          value={filterValue}
          onChange={handleChange}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          placeholder="e.g., *.json, data*, config*"
        />
        <div className="text-xs font-semibold text-gray-400 mt-2">
          Include Pattern applies filters to the selected items (files or
          folders). Only the files matching the filter within the selected items
          will be added to the cart.
        </div>
        <div className="text-xs font-semibold text-gray-400 mt-2">
          Use * as wildcard and ? for a single character (e.g., *.fastq for
          fastq extension files, data* for files starting with &#39;data&#39;).
        </div>
      </form>
    </div>
  );
};

export default FileFilters;
